import React, {useEffect} from 'react';
import {Empty} from './Empty';
import {styled} from '@volkswagen-onehub/components-core';
import useRootHistory from '../utils/use-root-history';
import {useOldParams} from '../store/old-params';
import {useParams} from 'react-router-dom';
import ResultsSkeleton from '../components/skeletons/ResultsSkeleton';
import useFetchFavourites from '../utils/use-fetch-favourites';
import FavouritesTopBar from './FavouritesTopBar';
import ResultsVehicle from '../components/ResultsVehicle';
import { FavouritesServiceResponse } from '../services/favourites-service';
import { VehicleData } from '../types';

const VehicleResultsContainer = styled.div`
  margin: 0 ${props => props.theme.size.grid002};
  max-width: 1750px;
`;

const FavouritesShared = () => {
  const params = useParams();
  const oldParams = useOldParams();

  const [loading, vehicleResponse] = useFetchFavourites(params.ulid);

  const vehicles = (vehicleResponse as FavouritesServiceResponse)?.data as VehicleData[];

  useRootHistory();

  useEffect(() => {
    return () => {
      oldParams.setOldParams(null);
    };
  }, []);

  return loading ? (
    <ResultsSkeleton />
  ) : vehicles?.length ? (
    <>
      <FavouritesTopBar />
        <VehicleResultsContainer>
          <ResultsVehicle
            showHeadline={false}
            vehicles={vehicles}
          />
        </VehicleResultsContainer>
    </>
  ) : (
    <Empty ulid={params.ulid} />
  );
};

export default FavouritesShared;
